import { render, staticRenderFns } from "./ModalEditarRespostaOcorrencia.vue?vue&type=template&id=64a06dc2&scoped=true"
import script from "./ModalEditarRespostaOcorrencia.vue?vue&type=script&lang=js"
export * from "./ModalEditarRespostaOcorrencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a06dc2",
  null
  
)

export default component.exports